<div class="SideBorder">
	<!--Title-->
	<h4>
		Manual Time Stamp
		<span *ngIf="PersonSelected() == true">(Selected: {{ SelectedPerson.FirstName }} {{ SelectedPerson.LastName }})</span>
	</h4>

	<!--Options-->
	<div class="Options">
		<button class="btn btn-primary" (click)="onSelector()">Selector</button>
		<button [disabled]="PersonSelected() == false" class="btn btn-primary SmallLeftMargin" (click)="onAlert()">Alert</button>
		<button [disabled]="PersonSelected() == false" class="btn btn-primary SmallLeftMargin" (click)="onAttendance()">Attendance</button>
		<button [disabled]="PersonSelected() == false" class="btn btn-primary SmallLeftMargin" (click)="onIDHistory()">ID History</button>
		<button [disabled]="PersonSelected() == false" class="btn btn-primary SmallLeftMargin" (click)="onSchedule()">Schedule</button>
	</div>

	<!--Display Menu based on option-->
	<div>
		<caass-scan-point-manual-selector *ngIf="Mode == 'Selector'" [FacilityID]="FacilityID" (PersonSelected)="onPersonSelected($event)">
		</caass-scan-point-manual-selector>

		<caass-scan-point-manual-alert *ngIf="Mode == 'Alert'" [FacilityID]="FacilityID" [SelectedPerson]="SelectedPerson"> </caass-scan-point-manual-alert>

		<caass-scan-point-manual-attendance *ngIf="Mode == 'Attendance'" [FacilityID]="FacilityID" [SelectedPerson]="SelectedPerson">
		</caass-scan-point-manual-attendance>

		<caass-scan-point-manual-id-history *ngIf="Mode == 'IDHistory'" [FacilityID]="FacilityID" [SelectedPerson]="SelectedPerson">
		</caass-scan-point-manual-id-history>

		<caass-scan-point-manual-schedule *ngIf="Mode == 'Schedule'" [FacilityID]="FacilityID" [SelectedPerson]="SelectedPerson">
		</caass-scan-point-manual-schedule>

		<caass-scan-point-manual-hall-pass
			*ngIf="Mode == 'HallPass'"
			[FacilityID]="FacilityID"
			[FacilityLocationID]="FacilityLocationID"
			[Receipt_IDPrinterID]="Receipt_IDPrinterID"
			[SelectedPerson]="SelectedPerson"
		>
		</caass-scan-point-manual-hall-pass>

		<caass-scan-point-manual-mark-time
			*ngIf="Mode == 'MarkTime'"
			[FacilityID]="FacilityID"
			[FacilityLocationID]="FacilityLocationID"
			[TimeScanTypeID]="TimeScanTypeID"
			[TimeScanTypeDesc]="TimeScanTypeDesc"
			[Receipt_IDPrinterID]="Receipt_IDPrinterID"
			[SelectedPerson]="SelectedPerson"
			(ManualScan)="onManualScan($event)"
			(CancelMarkTime)="onCancelMarkTime()"
		>
		</caass-scan-point-manual-mark-time>
	</div>

	<!--Buttons-->
	<div *ngIf="Mode != 'MarkTime'" class="Buttons">
		<button [disabled]="PersonSelected() == false" class="btn btn-primary SmallLeftMargin" (click)="onHallPass()">Hall Pass</button>
		<button [disabled]="PersonSelected() == false" class="btn btn-primary" (click)="onMarkTime()">Mark Time</button>
		<button class="btn btn-warning" (click)="onClose()">Close</button>
	</div>
</div>
